<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="blurry" placeholder="请输入角色名称或代码" clearable></el-input>
      <el-button type="primary" @click="getRoleList">查询</el-button>
      <el-button v-if="hasPer('role:add')" @click="editRole" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border height="calc(100vh - 180px)" max-height="calc(100vh - 180px)">
      <el-table-column label="序号" type="index" width="60"></el-table-column>
      <el-table-column label="角色名称" prop="roleName"></el-table-column>
<!--      <el-table-column label="角色代码" prop="roleCode"></el-table-column>-->
      <el-table-column label="角色说明" prop="description"></el-table-column>
      <el-table-column label="操作" prop="option" width="230px" align="center">
        <template slot-scope="scope">
          <span v-if="username === 'admin'">
            <el-button type="success" @click="authorizeRole(scope.row.id)">授权</el-button>
            <el-button type="primary" @click="editRole(JSON.parse(JSON.stringify(scope.row)))">编辑</el-button>
            <el-button type="danger" @click="delRole(scope.row.id, scope.row.roleName)">删除</el-button>
          </span>
          <span v-else>
            <el-button v-if="hasPer('role:authorize') && scope.row.roleCode!=='ADMIN' " type="success" @click="authorizeRole(scope.row.id)">授权</el-button>
            <el-button v-if="hasPer('role:edit') && scope.row.roleCode!=='ADMIN' " type="primary" @click="editRole(JSON.parse(JSON.stringify(scope.row)))">编辑</el-button>
            <el-button v-if="hasPer('role:del') && scope.row.roleCode!=='ADMIN' " type="danger" @click="delRole(scope.row.id, scope.row.roleName)">删除</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <!--编辑-->
    <edit-role :dialog-visible.sync="dialogVisible" :role-obj="roleObj" @get-list="getRoleList"></edit-role>
    <!--授权-->
    <authorize-role :auth-visible.sync="authVisible" :role-id="roleId"></authorize-role>
  </div>
</template>

<script>
import editRole from "./editRole.vue";
import authorizeRole from "./authorizeRole.vue";
import {delRole, getRoleList} from "../../../api/sys/role/sysRole";
import {infoMsg, successMsg} from "../../../utils/message";
import {hasPer} from "../../../utils/common";
import store from "@/store";

export default {
  name: "index",
  components: {
    editRole,
    authorizeRole
  },
  data(){
    return{
      blurry: '',
      tableData: [],
      username: store.state.userInfo.username,
      dialogVisible: false,
      authVisible: false,
      roleId: null,
      roleObj: {},
    }
  },
  mounted() {
    this.getRoleList()
  },
  methods: {
    hasPer,
    //  获取角色列表
    getRoleList(){
      getRoleList({blurry: this.blurry}).then(res => {
        this.tableData = res
      })
    },
    //  编辑角色
    editRole(row){
      this.dialogVisible = true
      this.roleObj = row.id ? row : {}
    },
    //  角色授权
    authorizeRole(id){
      this.authVisible = true
      this.roleId = id
    },
    //  删除角色
    delRole(id, name){
      this.$confirm('确定删除角色【'+name+'】？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delRole({id: id}).then(() => {
          successMsg('操作成功')
          this.getRoleList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    }
  }
}
</script>

<style scoped>

</style>